import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { BackendApiService } from "../../../app/services/backend-api.service";
import { DialogGraphscaleSettingsComponent } from '../dialog-graphscale-settings/dialog-graphscale-settings.component';
import { MatSnackBar, MatSnackBarVerticalPosition} from '@angular/material/snack-bar';
import * as CanvasJS from "../device-detail-nxt/canvasjs.stock.min";
import { BaseUrlConstantsService } from '../../../app/services/base-url-constants.service';
import { CommonModule } from '@angular/common';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { RadialGaugeComponent } from '../radial-gauge/radial-gauge.component';
import { LineChartComponent } from '../line-chart/line-chart.component';
import { GaugeChartComponent } from '../device-detail-nxt/gauge-chart-component/gauge-chart-component.component';
import { MatTooltip, MatTooltipModule } from '@angular/material/tooltip';
import { AssetStaticInfoComponent } from "../../../app/components/asset-static-info/asset-static-info.component";
import { ThermalsTabComponent } from "../../../app/components/thermals-tab/thermals-tab.component";
import { SuccessResponse } from './analysis.model';
import { SkeletonGaugeComponent } from "../../../app/components/skeleton-gauge/skeleton-gauge.component";
@Component({
  selector: 'app-analysis',
  templateUrl: './analysis.component.html',
  styleUrls: ['./analysis.component.css'],
  standalone: true,
  imports: [CommonModule, NgbNavModule, RadialGaugeComponent, LineChartComponent, GaugeChartComponent, MatTooltipModule, MatTooltip, AssetStaticInfoComponent, ThermalsTabComponent, SkeletonGaugeComponent]
})
export class AnalysisComponent implements OnInit {

  

  //Oil Temperature Radial-Gauge. 
  public eTxformerOilTemperatureData: any = [];
  //Oil Level Radial-Gauge. 
  public eTxformerOilLevelData: any = [];
  //Winding Temperature Radial-Gauge. 
  public tXformerWendingTemperatureData: any;
  public UpdateNeedle: number = 0;
  
  public tXformerTrendsOilTemperatureData: any;
  public tXformerTrendsOilLevelData: any;
  public tXformerTrendsWindingTemperatureData: any;
  public tXformerTrendsPressureReliefValveData: any;
  public tXformerTrendsBuchholzRelayData: any;
  public tXformerTrendsSurgeRelayData: any;

  //Energy Meter Screen Line Chart.
  //Voltage
  public emVoltageLineData: any;
  public VoltageLineChartOptions="";
  public VoltageLineChartColors:any;

  //Current
  public emCurrentLineData: any;
  public CurrentLineChartOptions="";
  public CurrentLineChartColors:any;

  //Frequency
  public emFrequencyLineData: any;
  public FrequencyLineChartOptions="";
  public FrequencyLineChartColors:any;
  
  //Power Factor
  public emPowerFactorLineData: any;
  public PowerFactorLineChartOptions="";
  public PowerFactorLineChartColors:any;  

  //KW Demand
  public emKwDemandLineData: any;
  public KwDemandLineChartOptions="";
  public KwDemandLineChartColors:any;
  
  //%THD
  public emTHDLineData: any;
  public THDLineChartOptions="";
  public THDLineChartColors:any;


  public TrendsOilTemperatureLineChartOptions="";
  public TrendsOilLevelLineChartOptions="";
  public TrendsWindingTemperatureLineChartOptions="";
  public TrendsPressureReliefValveLineChartOptions="";
  public TrendsBuchholzRelayLineChartOptions="";
  public TrendsSurgeRelayLineChartOptions="";

  public TrendsOilTemperatureLineChartColors:any;
  public TrendsOilLevelLineChartColors:any;
  public TrendsWindingTemperatureLineChartColors:any;
  public TrendsPressureReliefValveLineChartColors:any;
  public TrendsBuchholzRelayLineChartColors:any;
  public TrendsSurgeRelayLineChartColors:any;

  //Enerty Meter:: Gauge :: 3 Phase Load Current.
  public em3PhaseLoadCurrentData: any = [];

  //Enerty Meter:: Gauge :: 3 Phase Line Voltage.
  public em3PhaseLineVoltageData: any = [];

    //Enerty Meter:: Gauge :: Cumulative Energy.
    public emPowerFactorFrequencyData: any = [];

  //Enerty Meter:: Gauge :: Total Harmonic Distortion.
  public TotalHarmonicDistortionData: any =[];

  //Enerty Meter:: Gauge :: Cumulative Energy .
  public CumulativeEnergyData: any =[];

   //Enerty Meter:: Gauge :: Peak Demand.
   public emPeakDemandData: any =[]; 

   //Graph Min Max Graph Scale Settings.
   public settings: any;
   public GraphScaleSettingData: any;

   //spinner.
   windingtemperatureloading: boolean = true;
   trendsoiltemperatureloading: boolean = true;
   trendsoillevelloading: boolean = true;
   trendswindingtemperatureloading: boolean = true;
   trendspressurereliefvalveloading: boolean = true;
   trendsbuchholzrelayloading: boolean = true;
   trendssurgerelayloading: boolean = true;

   threephaseloadcurrentloading: boolean = true;
   threephaselinevoltageloading: boolean = true;   
   powerfactorloading: boolean = true;
   totalharmonicdistortionloading: boolean = true;   
   cumulativeenergyloading: boolean = true;
   peakdemandloading: boolean = true;
   
   trendsvoltageloading: boolean = true;
   trendscurrentloading: boolean = true;
   trendsfrequencyloading: boolean = true;
   trendspowerfactorloading: boolean = true;
   trendskwdemandloading: boolean = true;
   trendshtdloading: boolean = true;
   
    



  public sensorData = BaseUrlConstantsService.transformerApi;
  public emeterData = BaseUrlConstantsService.energyMeterApi;
  public deviceId: any;
  public assetId: any;
  public userID: any;
  public serialNo:any;
  public centralLabel = "";
  public canvasWidth = 160;
  public gaugeShow: boolean=false;
  public dataGadge: any;
  public Itemsymbol: any;
  public tabName = 'tab-2';
  tab1:any;
  tab3:any;
  tab4:any;
  public breadcrumbsArray: any = [
    {
      // page_ref: "device-reports",
      page_ref: "device-report-new",
      page_title: "Transformers",
    },
  ];
  public role :string;
  updateLoader: boolean=false;
  generic_asset_id: string;
  //myparameter static;

  /*
  constructor(
    public service: BackendApiService,
    public activeRoute: ActivatedRoute,
  ) { 
    if(localStorage.getItem('role') === 'CLIENT'){
      this.userID = localStorage.getItem('user_id');
      this.assetId =localStorage.getItem('assetId');
    }
    activeRoute.queryParams.subscribe(async (params) =>{
      this.deviceId = params[`deviceId`];
      console.log(this.deviceId,'deviceid')
    })
  }*/

  constructor(
    public service: BackendApiService,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar,
    public router : Router,
    public activeRoute: ActivatedRoute,

  ) { 
    // this.userID = 2;
    // this.assetId = 63;
    // this.deviceId=7;
    // this.serialNo='EM1234590';

    activeRoute.queryParams.subscribe((params) => {
      console.log("PARAMS IN ANALYSIS COMP")
      console.log(params)
      console.log(params)
      this.tab1 = params['tab1']
      this.tab3 = params['tab3']
      this.tab4 = params['tab4']
    })
  }
 
  ngOnInit(): void {
    this.getGaugeDataByID();
    this.getLineDataByID();
    this.getBarDataByID();
    // this.getEnergyMeterGaugeDataByID();
    // this.getEnergyMeterLineDataByID();
    this.getEmeterGraphScaleSettingsDataByID('OilTemperature',1457);
    this.getExformerGraphScaleSettingsDataByID('OilTemperature',1457);
    this.role = localStorage.getItem('role');
  }
  async goToPageLink(name: string) {
    const user=localStorage.getItem('Role');
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        tabName: this.tabName,
        tab1:this.tab1,
        tab2:true,
        tab3:this.tab3,
        tab4:this.tab4,
        clientName:localStorage.getItem('company_name'),
      },
    };
    this.router.navigate([user=='ADMIN'?'device-report-new':'device-reports'], navigationExtras);
  }
  //Graph Scale Setting Dialog Box Code Start.
  openExformerGraphSettingsDialog(metric_type:string,asset_id:number): void {

    this.getExformerGraphScaleSettingsDataByID(metric_type,asset_id);

    this.getExformerGraphScaleSettingsDataByID(metric_type, asset_id).then((data: any) => {

      //set data into GraphScaleSettingData variable. 
      this.GraphScaleSettingData=[];      
      let response = data.body;
      this.GraphScaleSettingData.push({
          metric_type:metric_type, 
          asset_id:asset_id, 
          threshold_1:response.threshold_1,
          threshold_2:response.threshold_2,
          threshold_3:response.threshold_3,
          max_value:response.max_value,
          base_value:response.base_value});

      //Open Dialog Box.
      const dialogRef = this.dialog.open(DialogGraphscaleSettingsComponent, {
        width: '800px',
        data: this.GraphScaleSettingData // Pass settings data to dialog
      });
  
      //Closed Dialog box
      dialogRef.afterClosed().subscribe(updatedSettings => {
        // console.log(updatedSettings)
        if (updatedSettings) {
          this.saveSettings(updatedSettings);
          // this.ngOnInit();
          // this.ngOnInit();

          // Show toast message
          

        }
      });

    }).catch(error => {
      console.error('Error fetching data:', error);
      // Handle error here
    });
  }

  openEmeterGraphSettingsDialog(metric_type:string,asset_id:number): void {

    this.getEmeterGraphScaleSettingsDataByID(metric_type,asset_id);

    this.getEmeterGraphScaleSettingsDataByID(metric_type, asset_id).then((data: any) => {

      //set data into GraphScaleSettingData variable. 
      this.GraphScaleSettingData=[];      
      let response = data.body;
      this.GraphScaleSettingData.push({metric_type:metric_type, asset_id:asset_id, green:response.threshold_1,yellow:response.threshold_2,red:response.threshold_3,max_value:response.max_value,min_value:response.base_value});

      //Open Dialog Box.
      const dialogRef = this.dialog.open(DialogGraphscaleSettingsComponent, {
        width: '800px',
        data: this.GraphScaleSettingData[0] // Pass settings data to dialog
      });
  
      //Closed Dialog box
      dialogRef.afterClosed().subscribe(updatedSettings => {
        if (updatedSettings) {
          this.saveSettings(updatedSettings);
          this.ngOnInit();
          this.ngOnInit();
          // Show toast message
          this._snackBar.open('Settings has been saved successfully.', 'Dismiss', {
            duration: 2000,
            horizontalPosition: 'center',
            verticalPosition: 'center' as MatSnackBarVerticalPosition, // Explicitly specify the type
            panelClass: ['custom-snackbar']
          });
        }
      });

    }).catch(error => {
      console.error('Error fetching data:', error);
      // Handle error here
    });
  }

  saveSettings(updatedSettings: any): void {
    this.service.saveSettings(this.sensorData+"/etxformer-graph-scale-settings-save",updatedSettings).then((res:SuccessResponse) => {
    // this.service.saveSettings("http://localhost:3104/exformer/etxformer-graph-scale-settings-save",updatedSettings[0]).then((res:SuccessResponse) => {
      const response=res.data
      if(response.code==200){
        this._snackBar.open('Settings has been saved successfully.', 'Dismiss', {
          duration: 2000,
          horizontalPosition: 'center',
          verticalPosition: 'top' as MatSnackBarVerticalPosition, // Explicitly specify the type
          panelClass: ['custom-snackbar']
        });
        console.log(updatedSettings[0].metric_type)
        switch(updatedSettings[0].metric_type){
          case "OilTemperature":
            this.getOilTemperatureData();
            break;
          case "OilLevel":
            this.getOilLevelData();
            break;
          case "WindingTemperature":
            this.getWindingTemperatureData();
            break;
        }
      }
      console.log('Settings saved successfully');
    }, error => {
      console.error('Error saving settings:', error);
    });
  }
  //Graph Scale Setting Dialog Box Code End.


  public async getGaugeDataByID(){

    this.getOilTemperatureData();

    this.getOilLevelData();

    this.getWindingTemperatureData()


      
  }

  public async getLineDataByID(){

    //Trends (Actual and Predicted):: Oil Temperature Data (Line Chart).    
    this.service.getDataWithQuery(this.sensorData+'/trends-oil-temperature/'+this.generic_asset_id).then((sRes) => {
      
      let sensorRes= JSON.parse(JSON.stringify(sRes)).data;

      if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {

        let response = sensorRes.body;
        this.tXformerTrendsOilTemperatureData =[];
        this.TrendsOilTemperatureLineChartColors =[];

        this.TrendsOilTemperatureLineChartOptions = response.name;

          if (response.sensor != undefined){

            if(response.sensor.length != 0){
              let barData= response.sensor;
              this.tXformerTrendsOilTemperatureData.push(barData);              
            }

            if(Object.keys(response.rangeLabels).length != 0){              
              this.TrendsOilTemperatureLineChartColors.push(response.rangeLabels);
            }            
           
            if(this.tXformerTrendsOilTemperatureData.length >=1 || this.TrendsOilTemperatureLineChartColors>0){              
              setTimeout(() => {
                this.trendsoiltemperatureloading = false;
              }, 1000);              
            }
            

          }
      }

    });

    this.service.getDataWithQuery(this.sensorData+'/trends-oil-level/'+this.generic_asset_id).then((sRes) => {
      
      let sensorRes= JSON.parse(JSON.stringify(sRes)).data;

      if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {

        let response = sensorRes.body;
        this.tXformerTrendsOilLevelData =[];
        this.TrendsOilLevelLineChartColors =[];

        this.TrendsOilLevelLineChartOptions = response.name;
          if (response.sensor != undefined){

            if(response.sensor.length != 0){
              let barData= response.sensor;
              this.tXformerTrendsOilLevelData.push(barData);
            }

            if(response.rangeLabels.length != 0){              
              this.TrendsOilLevelLineChartColors.push(response.rangeLabels);
            }

            if(this.tXformerTrendsOilLevelData.length >=1 || this.TrendsOilLevelLineChartColors>0){              
              setTimeout(() => {
                this.trendsoillevelloading = false;
              }, 1000);              
            }
            

          }
      }

    });

    this.service.getDataWithQuery(this.sensorData+'/trends-winding-temperature/'+this.generic_asset_id).then((sRes) => {
      
      let sensorRes= JSON.parse(JSON.stringify(sRes)).data;

      if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {

        let response = sensorRes.body;
        this.tXformerTrendsWindingTemperatureData =[];
        this.TrendsWindingTemperatureLineChartColors =[];

        this.TrendsWindingTemperatureLineChartOptions = response.name;
          if (response.sensor != undefined){

            if(response.sensor.length != 0){
              let barData= response.sensor;
              this.tXformerTrendsWindingTemperatureData.push(barData);              
            }

            if(response.rangeLabels.length != 0){              
              this.TrendsWindingTemperatureLineChartColors.push(response.rangeLabels);
            }

            if(this.tXformerTrendsWindingTemperatureData.length >=1 || this.TrendsWindingTemperatureLineChartColors>0){              
              setTimeout(() => {
                this.trendswindingtemperatureloading = false;
              }, 1000);              
            }

          }
      }

    });

  }

  public async getBarDataByID(){

    this.service.getDataWithQuery(this.sensorData+'/trends-pressure-relief-valve/'+this.generic_asset_id).then((sRes) => {
      
      let sensorRes= JSON.parse(JSON.stringify(sRes)).data;

      if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {

        let response = sensorRes.body;
        this.tXformerTrendsPressureReliefValveData =[];
        this.TrendsPressureReliefValveLineChartColors =[];

        this.TrendsPressureReliefValveLineChartOptions = response.name;
          if (response.sensor != undefined){

            if(response.sensor.length != 0){
              let barData= response.sensor;
              this.tXformerTrendsPressureReliefValveData.push(barData);              
            }

            if(response.rangeLabels.length != 0){              
              this.TrendsPressureReliefValveLineChartColors.push(response.rangeLabels);
            } 
            
            if(this.tXformerTrendsPressureReliefValveData.length >=1 || this.TrendsPressureReliefValveLineChartColors>0){              
              setTimeout(() => {
                this.trendspressurereliefvalveloading = false;
              }, 1000);              
            }
          }
      }

    });

    this.service.getDataWithQuery(this.sensorData+'/trends-buchholz-relay/'+this.generic_asset_id).then((sRes) => {
      
      let sensorRes= JSON.parse(JSON.stringify(sRes)).data;

      if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {

        let response = sensorRes.body;
        this.tXformerTrendsBuchholzRelayData =[];
        this.TrendsBuchholzRelayLineChartColors =[];

        this.TrendsBuchholzRelayLineChartOptions = response.name;
          if (response.sensor != undefined){

            if(response.sensor.length != 0){
              let barData= response.sensor;
              this.tXformerTrendsBuchholzRelayData.push(barData);              
            }

            if(response.rangeLabels.length != 0){              
              this.TrendsBuchholzRelayLineChartColors.push(response.rangeLabels);
            } 
            

            if(this.tXformerTrendsBuchholzRelayData.length >=1 || this.TrendsBuchholzRelayLineChartColors>0){              
              setTimeout(() => {
                this.trendsbuchholzrelayloading = false;
              }, 1000);              
            }
          }
      }

    });

    this.service.getDataWithQuery(this.sensorData+'/trends-oil-surge-relay/'+this.generic_asset_id).then((sRes) => {
      
      let sensorRes= JSON.parse(JSON.stringify(sRes)).data;

      if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {

        let response = sensorRes.body;
        this.tXformerTrendsSurgeRelayData =[];
        this.TrendsSurgeRelayLineChartColors =[];

        this.TrendsSurgeRelayLineChartOptions = response.name;
          if (response.sensor != undefined){

            if(response.sensor.length != 0){
              let barData= response.sensor;
              this.tXformerTrendsSurgeRelayData.push(barData);              
            }

            if(response.rangeLabels.length != 0){              
              this.TrendsSurgeRelayLineChartColors.push(response.rangeLabels);
            }

            if(this.tXformerTrendsSurgeRelayData.length >=1 || this.TrendsSurgeRelayLineChartColors>0){              
              setTimeout(() => {
                this.trendssurgerelayloading = false;
              }, 1000);              
            }



          }
      }

    });
  }

  public async getEnergyMeterGaugeDataByID(){

    //Enerty Meter:: Gauge Graph :: 3 Phase Load Current.
    this.service.getDataWithQuery(this.emeterData +"/3phase-load-current/"+this.generic_asset_id).then((sRes) => {

      let sensorRes= JSON.parse(JSON.stringify(sRes)).data;      
    
      if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {
      
        let response = sensorRes.body;
        this.em3PhaseLoadCurrentData =[];
        if (response.sensor != undefined){
          if(response.sensor.length != 0){

            this.dataGadge= response.sensor;

            if (this.dataGadge.length !== 0) {

              let tempArr = [];
              let bottomLab = "";
            
              for (let mCount = 0; mCount < this.dataGadge.length; mCount++) {
             
                if (JSON.parse(this.dataGadge[mCount].value) === 0 && this.dataGadge[mCount].needle === false) {

                    bottomLab = "N/A";
                } else {
                  bottomLab =JSON.parse(this.dataGadge[mCount].value) <= 0 ? "N/A": this.dataGadge[mCount].symbol === "C" ? JSON.parse(this.dataGadge[mCount].value) +
                        " °" + this.dataGadge[mCount].icon : JSON.parse(this.dataGadge[mCount].value) +" " +this.dataGadge[mCount].icon;
                }

                this.Itemsymbol = this.dataGadge[mCount].symbol;
                let needleValueRes;
                if (this.dataGadge[mCount].symbol === "m/sec²") {
                  needleValueRes = (JSON.parse(this.dataGadge[mCount].value) );
                } else if (this.dataGadge[mCount].symbol === "mm/sec") {
                  needleValueRes = (JSON.parse(this.dataGadge[mCount].value) );
                } else if (this.dataGadge[mCount].symbol === "deg") {
                  needleValueRes = JSON.parse(this.dataGadge[mCount].value);
                } else {
                  //needleValueRes = JSON.parse(this.dataGadge[mCount].value);
                  needleValueRes = (JSON.parse(this.dataGadge[mCount].value) );
                }

                let centerLab = JSON.parse(this.dataGadge[mCount].value) < 0 ? "N/A": JSON.parse(this.dataGadge[mCount].value);
                let arc_colors = this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].arcColors: ["transparent", "transparent", "transparent"];
                let range_label =this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].rangelabel: [];
                let arc_Delimiters = this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].arcDelimiters: [];
                let value = JSON.parse(this.dataGadge[mCount].value) < 0 ? "N/A": JSON.parse(this.dataGadge[mCount].value);

                const em3PhaseLoadCurrentAccelerationData = {
                  // value:value,
                  needleValue: needleValueRes,
                  centralLabel: centerLab,
                  outerNeedle: false,
                  canvasWidth: 150,
                  name: this.dataGadge[mCount].name,
                  key: this.dataGadge[mCount].key,
                  bottomLabel: bottomLab,
                  hasneedle: this.dataGadge[mCount].needle,
                  options: {
                    hasNeedle: this.dataGadge[mCount].needle,
                    needleColor: "black",
                    needleUpdateSpeed: "",
                    arcColors: arc_colors,
                    arcLabels: [] as string[],
                    arcDelimiters: this.dataGadge[mCount].arcDelimiters,
                    rangeLabel: range_label,
                    needleStartValue: 0,
                  },
                };

                if (arc_Delimiters[0] < 100 && arc_Delimiters[0] > 0 && arc_Delimiters[1] > 0 && arc_Delimiters[0] < arc_Delimiters[1] && arc_Delimiters[1] < 100) {

                  let max = range_label[1] != null ? range_label[1] : 0;
                  em3PhaseLoadCurrentAccelerationData.options.arcLabels[0] = sensorRes.body.rangeLabels.green;
                  em3PhaseLoadCurrentAccelerationData.options.arcLabels[1] = sensorRes.body.rangeLabels.yellow;
                  let velocityG = sensorRes.body.rangeLabels.green;
                  let velocityY = sensorRes.body.rangeLabels.yellow;
                  let velocityR = max;
                  em3PhaseLoadCurrentAccelerationData.options.arcColors[0] = "#72FF13";
                  em3PhaseLoadCurrentAccelerationData.options.arcColors[1] = "#FAA700";
                  em3PhaseLoadCurrentAccelerationData.options.arcColors[2] = "#ff2a1b";
      
                  if (
                    em3PhaseLoadCurrentAccelerationData.centralLabel <= em3PhaseLoadCurrentAccelerationData.options.arcLabels[0]
                  ) {
                    // accelerationData.options.centralLabel=
                    em3PhaseLoadCurrentAccelerationData.options.needleColor = "#72FF13";
                  } else if (
                    em3PhaseLoadCurrentAccelerationData.centralLabel > em3PhaseLoadCurrentAccelerationData.options.arcLabels[0] &&
                    em3PhaseLoadCurrentAccelerationData.centralLabel <= em3PhaseLoadCurrentAccelerationData.options.arcLabels[1]
                  ) {
                    em3PhaseLoadCurrentAccelerationData.options.needleColor = "#FAA700";
                  } else {
                    em3PhaseLoadCurrentAccelerationData.options.needleColor = "#ff2a1b";
                  }
      
                  this.em3PhaseLoadCurrentData.push(em3PhaseLoadCurrentAccelerationData);
                  this.gaugeShow=true;
                }

                if(this.em3PhaseLoadCurrentData.length >=1){                  
                  setTimeout(() => {
                    this.threephaseloadcurrentloading=false;
                  }, 1000);
                }
              
              }
              

            }

          }
              
        }

      }

    });

    //Enerty Meter:: Gauge Graph :: 3 Phase Line Voltage.
    this.service.getDataWithQuery(this.emeterData +"/3phase-line-voltage/"+this.generic_asset_id).then((sRes) => {

      let sensorRes= JSON.parse(JSON.stringify(sRes)).data;      
    
      if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {
      
        let response = sensorRes.body;
        this.em3PhaseLineVoltageData =[];
        if (response.sensor != undefined){
          if(response.sensor.length != 0){

            this.dataGadge= response.sensor;

            if (this.dataGadge.length !== 0) {

              let tempArr = [];
              let bottomLab = "";
            
              for (let mCount = 0; mCount < this.dataGadge.length; mCount++) {
             
                if (JSON.parse(this.dataGadge[mCount].value) === 0 && this.dataGadge[mCount].needle === false) {

                    bottomLab = "N/A";
                } else {
                  bottomLab =JSON.parse(this.dataGadge[mCount].value) <= 0 ? "N/A": this.dataGadge[mCount].symbol === "C" ? JSON.parse(this.dataGadge[mCount].value) +
                        " °" + this.dataGadge[mCount].icon : JSON.parse(this.dataGadge[mCount].value) +" " +this.dataGadge[mCount].icon;
                }

                this.Itemsymbol = this.dataGadge[mCount].symbol;
                let needleValueRes;
                if (this.dataGadge[mCount].symbol === "m/sec²") {
                  needleValueRes = (JSON.parse(this.dataGadge[mCount].value) );
                } else if (this.dataGadge[mCount].symbol === "mm/sec") {
                  needleValueRes = (JSON.parse(this.dataGadge[mCount].value) );
                } else if (this.dataGadge[mCount].symbol === "deg") {
                  needleValueRes = JSON.parse(this.dataGadge[mCount].value);
                } else {
                  //needleValueRes = JSON.parse(this.dataGadge[mCount].value);
                  needleValueRes = (JSON.parse(this.dataGadge[mCount].value));
                }

                let centerLab = JSON.parse(this.dataGadge[mCount].value) < 0 ? "N/A": JSON.parse(this.dataGadge[mCount].value);
                let arc_colors = this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].arcColors: ["transparent", "transparent", "transparent"];
                let range_label =this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].rangelabel: [];
                let arc_Delimiters = this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].arcDelimiters: [];
                let value = JSON.parse(this.dataGadge[mCount].value) < 0 ? "N/A": JSON.parse(this.dataGadge[mCount].value);

                const em3PhaseLineVoltageAccelerationData = {
                  // value:value,
                  needleValue: needleValueRes,
                  centralLabel: centerLab,
                  outerNeedle: false,
                  canvasWidth: 150,
                  name: this.dataGadge[mCount].name,
                  key: this.dataGadge[mCount].key,
                  bottomLabel: bottomLab,
                  hasneedle: this.dataGadge[mCount].needle,
                  options: {
                    hasNeedle: this.dataGadge[mCount].needle,
                    needleColor: "black",
                    needleUpdateSpeed: "",
                    arcColors: arc_colors,
                    arcLabels: [] as string[],
                    arcDelimiters: this.dataGadge[mCount].arcDelimiters,
                    rangeLabel: range_label,
                    needleStartValue: 0,
                  },
                };

                if (arc_Delimiters[0] < 100 && arc_Delimiters[0] > 0 && arc_Delimiters[1] > 0 && arc_Delimiters[0] < arc_Delimiters[1] && arc_Delimiters[1] < 100) {

                  let max = range_label[1] != null ? range_label[1] : 0;
                  em3PhaseLineVoltageAccelerationData.options.arcLabels[0] = sensorRes.body.rangeLabels.green;
                  em3PhaseLineVoltageAccelerationData.options.arcLabels[1] = sensorRes.body.rangeLabels.yellow;
                  let velocityG = sensorRes.body.rangeLabels.green;
                  let velocityY = sensorRes.body.rangeLabels.yellow;
                  let velocityR = max;
                  em3PhaseLineVoltageAccelerationData.options.arcColors[0] = "#72FF13";
                  em3PhaseLineVoltageAccelerationData.options.arcColors[1] = "#FAA700";
                  em3PhaseLineVoltageAccelerationData.options.arcColors[2] = "#ff2a1b";
      
                  if (
                    em3PhaseLineVoltageAccelerationData.centralLabel <= em3PhaseLineVoltageAccelerationData.options.arcLabels[0]
                  ) {
                    // accelerationData.options.centralLabel=
                    em3PhaseLineVoltageAccelerationData.options.needleColor = "#72FF13";
                  } else if (
                    em3PhaseLineVoltageAccelerationData.centralLabel > em3PhaseLineVoltageAccelerationData.options.arcLabels[0] &&
                    em3PhaseLineVoltageAccelerationData.centralLabel <= em3PhaseLineVoltageAccelerationData.options.arcLabels[1]
                  ) {
                    em3PhaseLineVoltageAccelerationData.options.needleColor = "#FAA700";
                  } else {
                    em3PhaseLineVoltageAccelerationData.options.needleColor = "#ff2a1b";
                  }
      
                  this.em3PhaseLineVoltageData.push(em3PhaseLineVoltageAccelerationData);
                  this.gaugeShow=true;
                }

                if(this.em3PhaseLineVoltageData.length >=1){                  
                  setTimeout(() => {
                   this.threephaselinevoltageloading=false;
                  }, 1000);
                }
              
              }
              

            }

          }
              
        }

      }

    });

    //Energy Meter:: Gauge Graph:: Power Factor / Frequency
    this.service.getDataWithQuery(this.emeterData +"/power-factor-frequency/"+this.generic_asset_id).then((sRes) => {

      let sensorRes= JSON.parse(JSON.stringify(sRes)).data;      
    
      if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {
      
        let response = sensorRes.body;
        this.emPowerFactorFrequencyData =[];
        if (response.sensor != undefined){
          if(response.sensor.length != 0){

            this.dataGadge= response.sensor;

            if (this.dataGadge.length !== 0) {

              let tempArr = [];
              let bottomLab = "";
            
              for (let mCount = 0; mCount < this.dataGadge.length; mCount++) {
             
                if (JSON.parse(this.dataGadge[mCount].value) === 0 && this.dataGadge[mCount].needle === false) {

                    bottomLab = "N/A";
                } else {
                  bottomLab =JSON.parse(this.dataGadge[mCount].value) <= 0 ? "N/A": this.dataGadge[mCount].symbol === "C" ? JSON.parse(this.dataGadge[mCount].value) +
                        " °" + this.dataGadge[mCount].icon : JSON.parse(this.dataGadge[mCount].value) +" " +this.dataGadge[mCount].icon;
                }

                this.Itemsymbol = this.dataGadge[mCount].symbol;
                let needleValueRes;
                if (this.dataGadge[mCount].symbol === "m/sec²") {
                  needleValueRes = (JSON.parse(this.dataGadge[mCount].value) );
                } else if (this.dataGadge[mCount].symbol === "mm/sec") {
                  needleValueRes = (JSON.parse(this.dataGadge[mCount].value) );
                } else if (this.dataGadge[mCount].symbol === "deg") {
                  needleValueRes = JSON.parse(this.dataGadge[mCount].value);
                } else {
                  //needleValueRes = JSON.parse(this.dataGadge[mCount].value);
                  needleValueRes = (JSON.parse(this.dataGadge[mCount].value) );
                }

                let centerLab = JSON.parse(this.dataGadge[mCount].value) < 0 ? "N/A": JSON.parse(this.dataGadge[mCount].value);
                let arc_colors = this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].arcColors: ["transparent", "transparent", "transparent"];
                let range_label =this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].rangelabel: [];
                let arc_Delimiters = this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].arcDelimiters: [];
                let value = JSON.parse(this.dataGadge[mCount].value) < 0 ? "N/A": JSON.parse(this.dataGadge[mCount].value);

                const emPowerFactorFrequencyAccelerationData = {
                  // value:value,
                  needleValue: needleValueRes,
                  centralLabel: centerLab,
                  outerNeedle: false,
                  canvasWidth: 150,
                  name: this.dataGadge[mCount].name,
                  key: this.dataGadge[mCount].key,
                  bottomLabel: bottomLab,
                  hasneedle: this.dataGadge[mCount].needle,
                  options: {
                    hasNeedle: this.dataGadge[mCount].needle,
                    needleColor: "black",
                    needleUpdateSpeed: "",
                    arcColors: arc_colors,
                    arcLabels: [] as string[],
                    arcDelimiters: this.dataGadge[mCount].arcDelimiters,
                    rangeLabel: range_label,
                    needleStartValue: 0,
                  },
                };

                if (arc_Delimiters[0] < 100 && arc_Delimiters[0] > 0 && arc_Delimiters[1] > 0 && arc_Delimiters[0] < arc_Delimiters[1] && arc_Delimiters[1] < 100) {

                  let max = range_label[1] != null ? range_label[1] : 0;
                  emPowerFactorFrequencyAccelerationData.options.arcLabels[0] = sensorRes.body.rangeLabels.green;
                  emPowerFactorFrequencyAccelerationData.options.arcLabels[1] = sensorRes.body.rangeLabels.yellow;
                  let velocityG = sensorRes.body.rangeLabels.green;
                  let velocityY = sensorRes.body.rangeLabels.yellow;
                  let velocityR = max;
                  emPowerFactorFrequencyAccelerationData.options.arcColors[0] = "#72FF13";
                  emPowerFactorFrequencyAccelerationData.options.arcColors[1] = "#FAA700";
                  emPowerFactorFrequencyAccelerationData.options.arcColors[2] = "#ff2a1b";
      
                  if (
                    emPowerFactorFrequencyAccelerationData.centralLabel <= emPowerFactorFrequencyAccelerationData.options.arcLabels[0]
                  ) {
                    // accelerationData.options.centralLabel=
                    emPowerFactorFrequencyAccelerationData.options.needleColor = "#72FF13";
                  } else if (
                    emPowerFactorFrequencyAccelerationData.centralLabel > emPowerFactorFrequencyAccelerationData.options.arcLabels[0] &&
                    emPowerFactorFrequencyAccelerationData.centralLabel <= emPowerFactorFrequencyAccelerationData.options.arcLabels[1]
                  ) {
                    emPowerFactorFrequencyAccelerationData.options.needleColor = "#FAA700";
                  } else {
                    emPowerFactorFrequencyAccelerationData.options.needleColor = "#ff2a1b";
                  }
      
                  this.emPowerFactorFrequencyData.push(emPowerFactorFrequencyAccelerationData);
                  this.gaugeShow=true;
                }
              
              }
              if(this.emPowerFactorFrequencyData.length >=1){                  
                setTimeout(() => {
                 this.powerfactorloading=false;
                }, 1000);
              }
              

            }

          }
              
        }

      }

    });

    //Enerty Meter:: Gauge Graph :: Total Harmonic Distortion.
    this.service.getDataWithQuery(this.emeterData +"/total-harmonic-distortion/"+this.generic_asset_id).then((sRes) => {

      let sensorRes= JSON.parse(JSON.stringify(sRes)).data;      
    
      if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {
      
        let response = sensorRes.body;
        this.TotalHarmonicDistortionData =[];
        if (response.sensor != undefined){
          if(response.sensor.length != 0){

            this.dataGadge= response.sensor;

            if (this.dataGadge.length !== 0) {

              let tempArr = [];
              let bottomLab = "";
            
              for (let mCount = 0; mCount < this.dataGadge.length; mCount++) {
             
                if (JSON.parse(this.dataGadge[mCount].value) === 0 && this.dataGadge[mCount].needle === false) {

                    bottomLab = "N/A";
                } else {
                  bottomLab =JSON.parse(this.dataGadge[mCount].value) <= 0 ? "N/A": this.dataGadge[mCount].symbol === "C" ? JSON.parse(this.dataGadge[mCount].value) +
                        " °" + this.dataGadge[mCount].icon : JSON.parse(this.dataGadge[mCount].value) +" " +this.dataGadge[mCount].icon;
                }

                this.Itemsymbol = this.dataGadge[mCount].symbol;
                let needleValueRes;
                if (this.dataGadge[mCount].symbol === "m/sec²") {
                  needleValueRes = (JSON.parse(this.dataGadge[mCount].value) );
                } else if (this.dataGadge[mCount].symbol === "mm/sec") {
                  needleValueRes = (JSON.parse(this.dataGadge[mCount].value) );
                } else if (this.dataGadge[mCount].symbol === "deg") {
                  needleValueRes = JSON.parse(this.dataGadge[mCount].value);
                } else {
                  //needleValueRes = JSON.parse(this.dataGadge[mCount].value);
                  needleValueRes = (JSON.parse(this.dataGadge[mCount].value) );
                }

                let centerLab = JSON.parse(this.dataGadge[mCount].value) < 0 ? "N/A": JSON.parse(this.dataGadge[mCount].value);
                let arc_colors = this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].arcColors: ["transparent", "transparent", "transparent"];
                let range_label =this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].rangelabel: [];
                let arc_Delimiters = this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].arcDelimiters: [];
                let value = JSON.parse(this.dataGadge[mCount].value) < 0 ? "N/A": JSON.parse(this.dataGadge[mCount].value);

                const tTotalHarmonicDistortionAccelerationData = {
                  // value:value,
                  needleValue: needleValueRes,
                  centralLabel: centerLab,
                  outerNeedle: false,
                  canvasWidth: 150,
                  name: this.dataGadge[mCount].name,
                  key: this.dataGadge[mCount].key,
                  bottomLabel: bottomLab,
                  hasneedle: this.dataGadge[mCount].needle,
                  options: {
                    hasNeedle: this.dataGadge[mCount].needle,
                    needleColor: "black",
                    needleUpdateSpeed: "",
                    arcColors: arc_colors,
                    arcLabels: [] as string[],
                    arcDelimiters: this.dataGadge[mCount].arcDelimiters,
                    rangeLabel: range_label,
                    needleStartValue: 0,
                  },
                };

                if (arc_Delimiters[0] < 100 && arc_Delimiters[0] > 0 && arc_Delimiters[1] > 0 && arc_Delimiters[0] < arc_Delimiters[1] && arc_Delimiters[1] < 100) {

                  let max = range_label[1] != null ? range_label[1] : 0;
                  tTotalHarmonicDistortionAccelerationData.options.arcLabels[0] = sensorRes.body.rangeLabels.green;
                  tTotalHarmonicDistortionAccelerationData.options.arcLabels[1] = sensorRes.body.rangeLabels.yellow;
                  let velocityG = sensorRes.body.rangeLabels.green;
                  let velocityY = sensorRes.body.rangeLabels.yellow;
                  let velocityR = max;
                  tTotalHarmonicDistortionAccelerationData.options.arcColors[0] = "#72FF13";
                  tTotalHarmonicDistortionAccelerationData.options.arcColors[1] = "#FAA700";
                  tTotalHarmonicDistortionAccelerationData.options.arcColors[2] = "#ff2a1b";
      
                  if (
                    tTotalHarmonicDistortionAccelerationData.centralLabel <= tTotalHarmonicDistortionAccelerationData.options.arcLabels[0]
                  ) {
                    // accelerationData.options.centralLabel=
                    tTotalHarmonicDistortionAccelerationData.options.needleColor = "#72FF13";
                  } else if (
                    tTotalHarmonicDistortionAccelerationData.centralLabel > tTotalHarmonicDistortionAccelerationData.options.arcLabels[0] &&
                    tTotalHarmonicDistortionAccelerationData.centralLabel <= tTotalHarmonicDistortionAccelerationData.options.arcLabels[1]
                  ) {
                    tTotalHarmonicDistortionAccelerationData.options.needleColor = "#FAA700";
                  } else {
                    tTotalHarmonicDistortionAccelerationData.options.needleColor = "#ff2a1b";
                  }
      
                  this.TotalHarmonicDistortionData.push(tTotalHarmonicDistortionAccelerationData);
                  this.gaugeShow=true;
                }
              
              }
              if(this.TotalHarmonicDistortionData.length >=1){                  
                setTimeout(() => {
                 this.totalharmonicdistortionloading=false;
                }, 1000);
              }

            }

          }
              
        }

      }

    });

    //Enerty Meter:: Gauge Graph :: Cumulative Energy.
    this.service.getDataWithQuery(this.emeterData +"/cumulative-energy/"+this.generic_asset_id).then((sRes) => {

      let sensorRes= JSON.parse(JSON.stringify(sRes)).data;      
    
      if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {
      
        let response = sensorRes.body;
        this.CumulativeEnergyData =[];
        if (response.sensor != undefined){
          if(response.sensor.length != 0){

            this.dataGadge= response.sensor;

            if (this.dataGadge.length !== 0) {

              let tempArr = [];
              let bottomLab = "";
            
              for (let mCount = 0; mCount < this.dataGadge.length; mCount++) {
             
                if (JSON.parse(this.dataGadge[mCount].value) === 0 && this.dataGadge[mCount].needle === false) {

                    bottomLab = "N/A";
                } else {
                  bottomLab =JSON.parse(this.dataGadge[mCount].value) <= 0 ? "N/A": this.dataGadge[mCount].symbol === "C" ? JSON.parse(this.dataGadge[mCount].value) +
                        " °" + this.dataGadge[mCount].icon : JSON.parse(this.dataGadge[mCount].value) +" " +this.dataGadge[mCount].icon;
                }

                this.Itemsymbol = this.dataGadge[mCount].symbol;
                let needleValueRes;
                if (this.dataGadge[mCount].symbol === "m/sec²") {
                  needleValueRes = (JSON.parse(this.dataGadge[mCount].value) );
                } else if (this.dataGadge[mCount].symbol === "mm/sec") {
                  needleValueRes = (JSON.parse(this.dataGadge[mCount].value) );
                } else if (this.dataGadge[mCount].symbol === "deg") {
                  needleValueRes = JSON.parse(this.dataGadge[mCount].value);
                } else {
                  //needleValueRes = JSON.parse(this.dataGadge[mCount].value);
                  needleValueRes = (JSON.parse(this.dataGadge[mCount].value) );
                }

                let centerLab = JSON.parse(this.dataGadge[mCount].value) < 0 ? "N/A": JSON.parse(this.dataGadge[mCount].value);
                let arc_colors = this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].arcColors: ["transparent", "transparent", "transparent"];
                let range_label =this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].rangelabel: [];
                let arc_Delimiters = this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].arcDelimiters: [];
                let value = JSON.parse(this.dataGadge[mCount].value) < 0 ? "N/A": JSON.parse(this.dataGadge[mCount].value);

                const CumulativeEnergyAccelerationData = {
                  // value:value,
                  needleValue: needleValueRes,
                  centralLabel: centerLab,
                  outerNeedle: false,
                  canvasWidth: 150,
                  name: this.dataGadge[mCount].name,
                  key: this.dataGadge[mCount].key,
                  bottomLabel: bottomLab,
                  hasneedle: this.dataGadge[mCount].needle,
                  options: {
                    hasNeedle: this.dataGadge[mCount].needle,
                    needleColor: "black",
                    needleUpdateSpeed: "",
                    arcColors: arc_colors,
                    arcLabels: [] as string[],
                    arcDelimiters: this.dataGadge[mCount].arcDelimiters,
                    rangeLabel: range_label,
                    needleStartValue: 0,
                  },
                };

                if (arc_Delimiters[0] < 100 && arc_Delimiters[0] > 0 && arc_Delimiters[1] > 0 && arc_Delimiters[0] < arc_Delimiters[1] && arc_Delimiters[1] < 100) {

                  let max = range_label[1] != null ? range_label[1] : 0;
                  CumulativeEnergyAccelerationData.options.arcLabels[0] = sensorRes.body.rangeLabels.green;
                  CumulativeEnergyAccelerationData.options.arcLabels[1] = sensorRes.body.rangeLabels.yellow;
                  let velocityG = sensorRes.body.rangeLabels.green;
                  let velocityY = sensorRes.body.rangeLabels.yellow;
                  let velocityR = max;
                  CumulativeEnergyAccelerationData.options.arcColors[0] = "#72FF13";
                  CumulativeEnergyAccelerationData.options.arcColors[1] = "#FAA700";
                  CumulativeEnergyAccelerationData.options.arcColors[2] = "#ff2a1b";
      
                  if (
                    CumulativeEnergyAccelerationData.centralLabel <= CumulativeEnergyAccelerationData.options.arcLabels[0]
                  ) {
                    // accelerationData.options.centralLabel=
                    CumulativeEnergyAccelerationData.options.needleColor = "#72FF13";
                  } else if (
                    CumulativeEnergyAccelerationData.centralLabel > CumulativeEnergyAccelerationData.options.arcLabels[0] &&
                    CumulativeEnergyAccelerationData.centralLabel <= CumulativeEnergyAccelerationData.options.arcLabels[1]
                  ) {
                    CumulativeEnergyAccelerationData.options.needleColor = "#FAA700";
                  } else {
                    CumulativeEnergyAccelerationData.options.needleColor = "#ff2a1b";
                  }
      
                  this.CumulativeEnergyData.push(CumulativeEnergyAccelerationData);
                  this.gaugeShow=true;
                }
              
              }

              if(this.CumulativeEnergyData.length >=1){                  
                setTimeout(() => {
                  this.cumulativeenergyloading=false;
                }, 1000);
              }
              

            }

          }
              
        }

      }

    });

     //Enerty Meter:: Gauge Graph :: Peak Demand.
     this.service.getDataWithQuery(this.emeterData +"/peak-demand/"+this.generic_asset_id).then((sRes) => {

      let sensorRes= JSON.parse(JSON.stringify(sRes)).data;      
    
      if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {
      
        let response = sensorRes.body;
        this.emPeakDemandData =[];
        if (response.sensor != undefined){
          if(response.sensor.length != 0){

            this.dataGadge= response.sensor;

            if (this.dataGadge.length !== 0) {

              let tempArr = [];
              let bottomLab = "";
            
              for (let mCount = 0; mCount < this.dataGadge.length; mCount++) {
             
                if (JSON.parse(this.dataGadge[mCount].value) === 0 && this.dataGadge[mCount].needle === false) {

                    bottomLab = "N/A";
                } else {
                  bottomLab =JSON.parse(this.dataGadge[mCount].value) <= 0 ? "N/A": this.dataGadge[mCount].symbol === "C" ? JSON.parse(this.dataGadge[mCount].value) +
                        " °" + this.dataGadge[mCount].icon : JSON.parse(this.dataGadge[mCount].value) +" " +this.dataGadge[mCount].icon;
                }

                this.Itemsymbol = this.dataGadge[mCount].symbol;
                let needleValueRes;
                if (this.dataGadge[mCount].symbol === "m/sec²") {
                  needleValueRes = (JSON.parse(this.dataGadge[mCount].value));
                } else if (this.dataGadge[mCount].symbol === "mm/sec") {
                  needleValueRes = (JSON.parse(this.dataGadge[mCount].value) );
                } else if (this.dataGadge[mCount].symbol === "deg") {
                  needleValueRes = JSON.parse(this.dataGadge[mCount].value);
                } else {
                  //needleValueRes = JSON.parse(this.dataGadge[mCount].value);
                  needleValueRes = (JSON.parse(this.dataGadge[mCount].value) );
                }

                let centerLab = JSON.parse(this.dataGadge[mCount].value) < 0 ? "N/A": JSON.parse(this.dataGadge[mCount].value);
                let arc_colors = this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].arcColors: ["transparent", "transparent", "transparent"];
                let range_label =this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].rangelabel: [];
                let arc_Delimiters = this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].arcDelimiters: [];
                let value = JSON.parse(this.dataGadge[mCount].value) < 0 ? "N/A": JSON.parse(this.dataGadge[mCount].value);

                const emPeakDemandAccelerationData = {
                  // value:value,
                  needleValue: needleValueRes,
                  centralLabel: centerLab,
                  outerNeedle: false,
                  canvasWidth: 150,
                  name: this.dataGadge[mCount].name,
                  key: this.dataGadge[mCount].key,
                  bottomLabel: bottomLab,
                  hasneedle: this.dataGadge[mCount].needle,
                  options: {
                    hasNeedle: this.dataGadge[mCount].needle,
                    needleColor: "black",
                    needleUpdateSpeed: "",
                    arcColors: arc_colors,
                    arcLabels: [] as string[],
                    arcDelimiters: this.dataGadge[mCount].arcDelimiters,
                    rangeLabel: range_label,
                    needleStartValue: 0,
                  },
                };

                if (arc_Delimiters[0] < 100 && arc_Delimiters[0] > 0 && arc_Delimiters[1] > 0 && arc_Delimiters[0] < arc_Delimiters[1] && arc_Delimiters[1] < 100) {

                  let max = range_label[1] != null ? range_label[1] : 0;
                  emPeakDemandAccelerationData.options.arcLabels[0] = sensorRes.body.rangeLabels.green;
                  emPeakDemandAccelerationData.options.arcLabels[1] = sensorRes.body.rangeLabels.yellow;
                  let velocityG = sensorRes.body.rangeLabels.green;
                  let velocityY = sensorRes.body.rangeLabels.yellow;
                  let velocityR = max;
                  emPeakDemandAccelerationData.options.arcColors[0] = "#72FF13";
                  emPeakDemandAccelerationData.options.arcColors[1] = "#FAA700";
                  emPeakDemandAccelerationData.options.arcColors[2] = "#ff2a1b";
      
                  if (
                    emPeakDemandAccelerationData.centralLabel <= emPeakDemandAccelerationData.options.arcLabels[0]
                  ) {
                    // accelerationData.options.centralLabel=
                    emPeakDemandAccelerationData.options.needleColor = "#72FF13";
                  } else if (
                    emPeakDemandAccelerationData.centralLabel > emPeakDemandAccelerationData.options.arcLabels[0] &&
                    emPeakDemandAccelerationData.centralLabel <= emPeakDemandAccelerationData.options.arcLabels[1]
                  ) {
                    emPeakDemandAccelerationData.options.needleColor = "#FAA700";
                  } else {
                    emPeakDemandAccelerationData.options.needleColor = "#ff2a1b";
                  }
      
                  this.emPeakDemandData.push(emPeakDemandAccelerationData);
                  this.gaugeShow=true;
                }
              
              }

              if(this.emPeakDemandData.length >=1){                  
                setTimeout(() => {
                  this.peakdemandloading=false;
                }, 1000);
              }
              

            }

          }
              
        }

      }

    });
  }

  public async getEnergyMeterLineDataByID(){

    //Enerty Meter:: Line Graph :: voltage.      
    this.service.getDataWithQuery(this.emeterData+'/trends-voltage/'+this.generic_asset_id).then((sRes) => {
      
      let sensorRes= JSON.parse(JSON.stringify(sRes)).data;

      if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {

        let response = sensorRes.body;
        this.emVoltageLineData =[];
        this.VoltageLineChartColors =[];

        this.VoltageLineChartOptions = response.name;

          if (response.sensor != undefined){

            if(response.sensor.length != 0){
              let barData= response.sensor;
              this.emVoltageLineData.push(barData);              
            }

            if(response.rangeLabels.length != 0){              
              this.VoltageLineChartColors.push(response.rangeLabels);
            }
            
            if(this.emVoltageLineData.length >=1 || this.VoltageLineChartColors.length >=1){                  
              setTimeout(() => {
                this.trendsvoltageloading=false;
              }, 1000);
            }

          }
      }

    });

    //Enerty Meter:: Line Graph :: Current.      
    this.service.getDataWithQuery(this.emeterData+'/trends-current/'+this.generic_asset_id).then((sRes) => {
      
      let sensorRes= JSON.parse(JSON.stringify(sRes)).data;

      if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {

        let response = sensorRes.body;
        this.emCurrentLineData =[];
        this.CurrentLineChartColors =[];

        this.CurrentLineChartOptions = response.name;

          if (response.sensor != undefined){

            if(response.sensor.length != 0){
              let barData= response.sensor;
              this.emCurrentLineData.push(barData);              
            }

            if(response.rangeLabels.length != 0){              
              this.CurrentLineChartColors.push(response.rangeLabels);
            }
            
            if(this.CurrentLineChartColors.length >=1 || this.emCurrentLineData.length >=1){                  
              setTimeout(() => {
                this.trendscurrentloading=false;
              }, 1000);
            }        

          }
      }

    });

    //Enerty Meter:: Line Graph :: Current.      
    this.service.getDataWithQuery(this.emeterData+'/trends-frequency/'+this.generic_asset_id).then((sRes) => {
      
      let sensorRes= JSON.parse(JSON.stringify(sRes)).data;

      if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {

        let response = sensorRes.body;
        this.emFrequencyLineData =[];
        this.FrequencyLineChartColors =[];

        this.FrequencyLineChartOptions = response.name;

          if (response.sensor != undefined){

            if(response.sensor.length != 0){
              let barData= response.sensor;
              this.emFrequencyLineData.push(barData);              
            }

            if(response.rangeLabels.length != 0){              
              this.FrequencyLineChartColors.push(response.rangeLabels);
            }
            
            if(this.emFrequencyLineData.length >=1 || this.FrequencyLineChartColors.length >=1){                  
              setTimeout(() => {
                this.trendsfrequencyloading=false;
              }, 1000);
            } 

          }
      }

    });

    //Enerty Meter:: Line Graph :: Power Factor.      
    this.service.getDataWithQuery(this.emeterData+'/trends-power-factor/'+this.generic_asset_id).then((sRes) => {
      
      let sensorRes= JSON.parse(JSON.stringify(sRes)).data;

      if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {

        let response = sensorRes.body;
        this.emPowerFactorLineData =[];
        this.PowerFactorLineChartColors =[];

        this.PowerFactorLineChartOptions = response.name;

          if (response.sensor != undefined){

            if(response.sensor.length != 0){
              let barData= response.sensor;
              this.emPowerFactorLineData.push(barData);              
            }

            if(response.rangeLabels.length != 0){              
              this.PowerFactorLineChartColors.push(response.rangeLabels);
            }
            
            if(this.emPowerFactorLineData.length >=1 || this.PowerFactorLineChartColors.length >=1){                  
              setTimeout(() => {
                this.trendspowerfactorloading=false;
              }, 1000);
            } 

          }
      }

    });

    //Enerty Meter:: Line Graph :: KW Demand.      
    this.service.getDataWithQuery(this.emeterData+'/trends-kw-demand/'+this.generic_asset_id).then((sRes) => {
      
      let sensorRes= JSON.parse(JSON.stringify(sRes)).data;

      if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {

        let response = sensorRes.body;
        this.emKwDemandLineData =[];
        this.KwDemandLineChartColors =[];

        this.KwDemandLineChartOptions = response.name;
        if (response.sensor != undefined){

          if(response.sensor.length != 0){
            let barData= response.sensor;
            this.emKwDemandLineData.push(barData);              
          }

          if(response.rangeLabels.length != 0){              
            this.KwDemandLineChartColors.push(response.rangeLabels);
          }
          
          if(this.emKwDemandLineData.length >=1 || this.KwDemandLineChartColors.length >=1){                  
            setTimeout(() => {
              this.trendskwdemandloading=false;
            }, 1000);
          } 

        }
      }

    });

    //Enerty Meter:: Line Graph :: KW Demand.      
    this.service.getDataWithQuery(this.emeterData+'/trends-harmonic-distortion/'+this.generic_asset_id).then((sRes) => {
      
      let sensorRes= JSON.parse(JSON.stringify(sRes)).data;

      if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {

        let response = sensorRes.body;
        this.emTHDLineData =[];
        this.THDLineChartColors =[];

        this.THDLineChartOptions = response.name;
        if (response.sensor != undefined){

          if(response.sensor.length != 0){
            let barData= response.sensor;
            this.emTHDLineData.push(barData);              
          }

          if(response.rangeLabels.length != 0){              
            this.THDLineChartColors.push(response.rangeLabels);
          }

          if(this.emTHDLineData.length >=1 || this.THDLineChartColors.length >=1){                  
            setTimeout(() => {
              this.trendshtdloading=false;
            }, 1000);
          }      

        }
      }

    });

  }

  public async getExformerGraphScaleSettingsDataByID(metric_type: string, asset_id: number): Promise<any> {
    try {
      const sensorRes = await this.service.getDataWithQuery(`${this.sensorData}/etxformer-graph-scale-settings/${metric_type}/${asset_id}`).then(res =>{
        return res;
      });
      const sensorBody = JSON.parse(JSON.stringify(sensorRes)).data;
  
      if (sensorBody && Object.keys(sensorBody).length !== 0) {
        return sensorBody;
      } else {
        throw new Error('No data found in sensor response');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error; // Rethrow the error to be handled by the caller
    }
  }

  public async getEmeterGraphScaleSettingsDataByID(metric_type: string, asset_id: number): Promise<any> {
    try {
      const sensorRes = await this.service.getDataWithQuery(`${this.emeterData}/emeter-graph-scale-settings/${metric_type}/${asset_id}`)
      .then(res => {
        return res
      });
      const sensorBody = JSON.parse(JSON.stringify(sensorRes)).data;
  
      if (sensorBody && Object.keys(sensorBody).length !== 0) {
        return sensorBody;
      } else {
        throw new Error('No data found in sensor response');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error; // Rethrow the error to be handled by the caller
    }
  }

  getOilTemperatureData(){
    //Radial-Gauge:: Oil Temperature Data.
    this.updateLoader=true; 
    this.service.getDataWithQuery(this.sensorData +"/oil-temperature/"+this.generic_asset_id).then((sRes) => {

      let sensorRes= JSON.parse(JSON.stringify(sRes)).data;      
    
    if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {
     
      let response = sensorRes.body;
      this.eTxformerOilTemperatureData =[];
      if (response.sensor != undefined){
        if(response.sensor.length != 0){

          let gaugeData= response.sensor;
          let needleValueRes;

          if (gaugeData[0].symbol === "C") {              
            needleValueRes = (JSON.parse(gaugeData[0].value));                
          }

          let centerLab = JSON.parse(gaugeData[0].value) < 0 ? "N/A": JSON.parse(gaugeData[0].value);
          let arc_colors = gaugeData[0].needle === true ? gaugeData[0].arcColors: ["transparent", "transparent", "transparent"];
          let range_label = gaugeData[0].needle === true ? gaugeData[0].rangelabel: [];
          let arc_Delimiters = gaugeData[0].needle === true ? gaugeData[0].arcDelimiters: [];            
          let bottomLab = "N/A";

          bottomLab = JSON.parse(gaugeData[0].value) <= 0 ? "N/A": gaugeData[0].symbol === "C"
          ? JSON.parse(gaugeData[0].value) +" °" +gaugeData[0].icon: JSON.parse(gaugeData[0].value) + " " + gaugeData[0].icon;
          
          const OilTempAccelerationData = {
            // value:value,
            needleValue: needleValueRes,
            centralLabel: centerLab,
            outerNeedle: false,
            canvasWidth: 150,
            name: gaugeData[0].name,
            key: gaugeData[0].key,
            bottomLabel: bottomLab,
            hasneedle:true,
            options: {
              hasNeedle: gaugeData[0].needle,
              needleColor: "black",
              needleUpdateSpeed: "",
              arcColors: arc_colors,
              //arcLabels: [],
              arcLabels: [] as string[],
              arcDelimiters: gaugeData[0].arcDelimiters,
              rangeLabel: range_label,
              needleStartValue: 0,
            },
          };
          
         
          if (arc_Delimiters[0] < 100 && arc_Delimiters[0] > 0 && arc_Delimiters[1] > 0 && arc_Delimiters[0] < arc_Delimiters[1] && arc_Delimiters[1] < 100) {
            let max = range_label[1] != null ? range_label[1] : 0;

            OilTempAccelerationData.options.arcLabels[0] = sensorRes.body.rangeLabels.green;
            OilTempAccelerationData.options.arcLabels[1] = sensorRes.body.rangeLabels.yellow;
            let velocityG = sensorRes.body.rangeLabels.green;
            let velocityY = sensorRes.body.rangeLabels.yellow;
            let velocityR = max;
            OilTempAccelerationData.options.arcColors[0] = "#72FF13";
            OilTempAccelerationData.options.arcColors[1] = "#FAA700";
            OilTempAccelerationData.options.arcColors[2] = "#ff2a1b";

            if (
              OilTempAccelerationData.centralLabel <=
              OilTempAccelerationData.options.arcLabels[0]
            ) {
              // accelerationData.options.centralLabel=
              OilTempAccelerationData.options.needleColor = "#72FF13";
            } else if (
              OilTempAccelerationData.centralLabel >
              OilTempAccelerationData.options.arcLabels[0] &&
              OilTempAccelerationData.centralLabel <=
              OilTempAccelerationData.options.arcLabels[1]
            ) {
              OilTempAccelerationData.options.needleColor = "#FAA700";
            } else {
              OilTempAccelerationData.options.needleColor = "#ff2a1b";
            }
            OilTempAccelerationData.centralLabel = OilTempAccelerationData.centralLabel;

            this.eTxformerOilTemperatureData.push(OilTempAccelerationData);
            this.gaugeShow=true;

        }

        }
        
      }

    }

  }).finally(()=>{
    this.updateLoader=false;
  })
  }

  getOilLevelData(){
        //Radial-Gauge:: Oil Level Data.
        this.service.getDataWithQuery(this.sensorData +"/oil-level/"+this.generic_asset_id).then((sRes) => {

          let sensorRes= JSON.parse(JSON.stringify(sRes)).data;      
        
        if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {
         
          let response = sensorRes.body;
          this.eTxformerOilLevelData =[];
          if (response.sensor != undefined){
            if(response.sensor.length != 0){
  
              let gaugeData= response.sensor;
              let needleValueRes;
              if (gaugeData[0].symbol === "C") {              
                needleValueRes = (JSON.parse(gaugeData[0].value));                
              }
  
              let centerLab = JSON.parse(gaugeData[0].value) < 0 ? "N/A": JSON.parse(gaugeData[0].value);
  
              let arc_colors = gaugeData[0].needle === true ? gaugeData[0].arcColors: ["transparent", "transparent", "transparent"];
  
              let range_label = gaugeData[0].needle === true ? gaugeData[0].rangelabel: [];
  
              let arc_Delimiters = gaugeData[0].needle === true ? gaugeData[0].arcDelimiters: [];
              
              let bottomLab = "N/A";
              
              bottomLab = JSON.parse(gaugeData[0].value) <= 0 ? "N/A": gaugeData[0].symbol === "C"
                  ? JSON.parse(gaugeData[0].value) +" °" +gaugeData[0].icon: JSON.parse(gaugeData[0].value) + " " + gaugeData[0].icon;
  
              const OilLevelAccelerationData = {
                // value:value,
                needleValue: needleValueRes,
                centralLabel: centerLab,
                outerNeedle: false,
                canvasWidth: 150,
                name: gaugeData[0].name,
                key: gaugeData[0].key,
                bottomLabel: bottomLab,
                hasneedle:true,
                options: {
                  hasNeedle: gaugeData[0].needle,
                  needleColor: "black",
                  needleUpdateSpeed: "",
                  arcColors: arc_colors,
                  //arcLabels: [],
                  arcLabels: [] as string[],
                  arcDelimiters: gaugeData[0].arcDelimiters,
                  rangeLabel: range_label,
                  needleStartValue: 0,
                },
              };
              
             
              if (arc_Delimiters[0] < 100 && arc_Delimiters[0] > 0 && arc_Delimiters[1] > 0 && arc_Delimiters[0] < arc_Delimiters[1] && arc_Delimiters[1] < 100) {
                
                let max = range_label[1] != null ? range_label[1] : 0;
  
                OilLevelAccelerationData.options.arcLabels[0] = sensorRes.body.rangeLabels.green;
                OilLevelAccelerationData.options.arcLabels[1] = sensorRes.body.rangeLabels.yellow;
                let velocityG = sensorRes.body.rangeLabels.green;
                let velocityY = sensorRes.body.rangeLabels.yellow;
                let velocityR = max;
                OilLevelAccelerationData.options.arcColors[0] = "#72FF13";
                OilLevelAccelerationData.options.arcColors[1] = "#FAA700";
                OilLevelAccelerationData.options.arcColors[2] = "#ff2a1b";
  
                if (
                  OilLevelAccelerationData.centralLabel <=
                  OilLevelAccelerationData.options.arcLabels[0]
                ) {
                  // accelerationData.options.centralLabel=
                  OilLevelAccelerationData.options.needleColor = "#72FF13";
                } else if (
                  OilLevelAccelerationData.centralLabel >
                  OilLevelAccelerationData.options.arcLabels[0] &&
                  OilLevelAccelerationData.centralLabel <=
                  OilLevelAccelerationData.options.arcLabels[1]
                ) {
                  OilLevelAccelerationData.options.needleColor = "#FAA700";
                } else {
                  OilLevelAccelerationData.options.needleColor = "#ff2a1b";
                }
  
                this.eTxformerOilLevelData.push(OilLevelAccelerationData);
                console.log( this.eTxformerOilLevelData,' this.eTxformerOilLevelData');
                this.gaugeShow=true;
            }
            
            }
            
          }
  
        }
  
      });
  }

  getWindingTemperatureData(){
        //Radial-Gauge:: Winding Temperature Data.
        this.service.getDataWithQuery(this.sensorData +"/winding-temperature/"+this.generic_asset_id).then((sRes) => {

          let sensorRes= JSON.parse(JSON.stringify(sRes)).data;      
        
          if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {
          
            let response = sensorRes.body;
            this.tXformerWendingTemperatureData =[];
            if (response.sensor != undefined){
              if(response.sensor.length != 0){
    
                this.dataGadge= response.sensor;
    
                if (this.dataGadge.length !== 0) {
    
                  let tempArr = [];
                  let bottomLab = "";
                
                  for (let mCount = 0; mCount < this.dataGadge.length; mCount++) {
    
                    
    
    
                 
                    if (JSON.parse(this.dataGadge[mCount].value) === 0 && this.dataGadge[mCount].needle === false) {
    
                        bottomLab = "N/A";
                    } else {
                      bottomLab =JSON.parse(this.dataGadge[mCount].value) <= 0 ? "N/A": this.dataGadge[mCount].symbol === "C" ? JSON.parse(this.dataGadge[mCount].value) +
                            " °" + this.dataGadge[mCount].icon : JSON.parse(this.dataGadge[mCount].value) +" " +this.dataGadge[mCount].icon;
                    }
    
                    this.Itemsymbol = this.dataGadge[mCount].symbol;
                    let needleValueRes;
                    if (this.dataGadge[mCount].symbol === "m/sec²") {
                      needleValueRes = (JSON.parse(this.dataGadge[mCount].value));
                    } else if (this.dataGadge[mCount].symbol === "mm/sec") {
                      needleValueRes = (JSON.parse(this.dataGadge[mCount].value));
                    } else if (this.dataGadge[mCount].symbol === "deg") {
                      needleValueRes = JSON.parse(this.dataGadge[mCount].value);
                    } else {
                      //needleValueRes = JSON.parse(this.dataGadge[mCount].value);
                      needleValueRes = (JSON.parse(this.dataGadge[mCount].value) );
                    }
    
                    let centerLab = JSON.parse(this.dataGadge[mCount].value) < 0 ? "N/A": JSON.parse(this.dataGadge[mCount].value);
                    let arc_colors = this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].arcColors: ["transparent", "transparent", "transparent"];
                    let range_label =this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].rangelabel: [];
                    let arc_Delimiters = this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].arcDelimiters: [];
                    let value = JSON.parse(this.dataGadge[mCount].value) < 0 ? "N/A": JSON.parse(this.dataGadge[mCount].value);
    
                    const WindingTemperatureAccelerationData = {
                      // value:value,
                      needleValue: needleValueRes,
                      centralLabel: centerLab,
                      outerNeedle: false,
                      canvasWidth: 150,
                      name: this.dataGadge[mCount].name,
                      key: this.dataGadge[mCount].key,
                      bottomLabel: bottomLab,
                      hasneedle: this.dataGadge[mCount].needle,
                      options: {
                        hasNeedle: this.dataGadge[mCount].needle,
                        needleColor: "black",
                        needleUpdateSpeed: "",
                        arcColors: arc_colors,
                        arcLabels: [] as string[],
                        arcDelimiters: this.dataGadge[mCount].arcDelimiters,
                        rangeLabel: range_label,
                        needleStartValue: 0,
                      },
                    };
    
                    if (arc_Delimiters[0] < 100 && arc_Delimiters[0] > 0 && arc_Delimiters[1] > 0 && arc_Delimiters[0] < arc_Delimiters[1] && arc_Delimiters[1] < 100) {
    
                      let max = range_label[1] != null ? range_label[1] : 0;
                      WindingTemperatureAccelerationData.options.arcLabels[0] = sensorRes.body.rangeLabels.green;
                      WindingTemperatureAccelerationData.options.arcLabels[1] = sensorRes.body.rangeLabels.yellow;
                      let velocityG = sensorRes.body.rangeLabels.green;
                      let velocityY = sensorRes.body.rangeLabels.yellow;
                      let velocityR = max;
                      WindingTemperatureAccelerationData.options.arcColors[0] = "#72FF13";
                      WindingTemperatureAccelerationData.options.arcColors[1] = "#FAA700";
                      WindingTemperatureAccelerationData.options.arcColors[2] = "#ff2a1b";
          
                      if (
                        WindingTemperatureAccelerationData.centralLabel <= WindingTemperatureAccelerationData.options.arcLabels[0]
                      ) {
                        // accelerationData.options.centralLabel=
                        WindingTemperatureAccelerationData.options.needleColor = "#72FF13";
                      } else if (
                        WindingTemperatureAccelerationData.centralLabel > WindingTemperatureAccelerationData.options.arcLabels[0] &&
                        WindingTemperatureAccelerationData.centralLabel <= WindingTemperatureAccelerationData.options.arcLabels[1]
                      ) {
                        WindingTemperatureAccelerationData.options.needleColor = "#FAA700";
                      } else {
                        WindingTemperatureAccelerationData.options.needleColor = "#ff2a1b";
                      }
          
                      this.tXformerWendingTemperatureData.push(WindingTemperatureAccelerationData);
                      console.log(this.tXformerWendingTemperatureData,'this.tXformerWendingTemperatureData')
                      
                      setTimeout(() => {
                        this.windingtemperatureloading = false;
                      }, 1000); 
                      
                      this.gaugeShow=true;
                    }
                  
                  }
                  
    
                }
    
              }
                  
            }
    
          }
    
        });
  }

}